<script>
import { userTypes } from "@/store/types/types.js";
import Search from "@/components/Search";
import SmallModal from "@/components/SmallModal";
import CustomerModal from "@/components/CustomerModal";
export default {
  name: "customer-information",
  components: {
    Search,
    SmallModal,
    CustomerModal
  },
  data() {
    return {
      userList: [],
      modalState: "",
      index: -1,
      title: "",
      printUserCard: null,
      length: 0
    };
  },
  computed: {
    keyword() {
      return this.$store.getters[userTypes.getters.getKeyword];
    },
    list() {
      return this.$store.getters[userTypes.getters.getUserList];
    }
  },
  methods: {
    openUserDetail(id) {
      this.userList = this.userList.filter(user => {
        if (user.id === id) {
          user.state = !user.state;
        }
        return user;
      });
    },
    resetIndex(data) {
      this.index = data;
    },
    printUser(user) {
      this.$jquery("#printModal").modal("show");
      this.printUserCard = user;
    },
    search(data) {
      if (!data.q) delete data.q;
      this.$store.dispatch(userTypes.actions.QUERY_USER_LIST, data);
      let container = this.$el.querySelector(".scroll-view");
      container.scrollTop = -container.scrollHeight;
      this.$store.dispatch(userTypes.actions.GET_SEARCH_KEYWORD, data);
    },
    goToOrderList(index) {
      this.$router.push({ name: "view-order", params: { id: index } });
    },
    numberChangeToWeekDay(list) {
      if (!list) return null;
      return list
        .map(weekday => {
          switch (weekday) {
            case "1":
              return "星期一";
            case "2":
              return "星期二";
            case "3":
              return "星期三";
            case "4":
              return "星期四";
            case "5":
              return "星期五";
            default:
              break;
          }
        })
        .join("、");
    },
    showDefaultOrderInList(order) {
      return `${order.description}：${order.price}、白飯數量： ${
        order.rice
      }、自訂：${order.customized_label || ""} ${order.customized_price || ""}`;
    },
    editUser(index) {
      this.index = index;
      this.title = "編輯顧客";
    },
    deleteUser(id) {
      this.index = id;
    },
    clickCheckByModal() {
      this.$htmlToPaper("printCustomerCard");
    },
    checkDeleteUser() {
      this.$store
        .dispatch(userTypes.actions.DELETE_USER, this.index)
        .then(async res => {
          await res;
          if (res.data.result == "fail") {
            alert(`${res.data.message}`);
          }
          if (res.data.result == "success") {
            alert("刪除成功！");
          }
        });
    },
    createUser() {
      this.index = -1;
      this.title = "新增顧客";
    },
    keepSearch() {
      if (this.keyword.q) {
        this.search(this.keyword);
      }
    }
  },
  mounted() {
    this.$store
      .dispatch(userTypes.actions.GET_USER_LIST_LENGTH)
      .then(length => {
        this.length = length;
      });
    this.$store.dispatch(userTypes.actions.QUERY_USER_LIST).then(() => {
      this.userList = this.list;
      this.keepSearch();
    });
  },
  watch: {
    list: {
      handler(val) {
        this.userList = val;
      },
      deep: true
    }
  }
};
</script>


<template src="./template.html"></template>
<style lang="scss" src="./style.scss"/>
